
import {defineComponent, PropType} from "vue";
import {mapActions, mapMutations} from "vuex";
import DownloadActionMixins from "@/mixins/DownloadActionMixins";

type DataProps = {
  downloads: number,
  version_id: number,
  size: string,
}

export default defineComponent({
  name: 'DownloadComponent',
  mixins: [DownloadActionMixins],
  props: {
    data: {
      type: Object as PropType<DataProps>,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  methods: {
    downloadAction() {
      this.downloadActionMixin(this.data.version_id, this.title)
    }
  }
})
